import { EvidenceFieldRow } from 'components/tables/data/evidence-field/types';
import P2Medium from 'components/typography/P2Medium';

/**
 * Column for the evidence field name.
 */
export default function FieldNameColumn({ data: { fieldName } }: { data: EvidenceFieldRow }) {
  return <P2Medium color="gray.8">{fieldName}</P2Medium>;
}
